import angular from 'angular';
import kformUtils from '../../utils/kform-utils';
import template from './smartfield.html';
import SmartFieldComponent from './smartfield.component';

const smartfieldConfig = /* @ngInject */ (/** @type {any} */ KformComponentsProvider) => {
	KformComponentsProvider.register('smartfield', {
		title: 'Smart Field',
		template,
		icon: 'fa fa-outdent',
		tableView: (/** @type {any} */ data) => (data ? data.name : ''),
		children:   false,
		selectable: true,
		settings:   new SmartFieldComponent(),
		views: [
			{
				name: 'Display',
				template: 'kform/components/smartfield/display.html',
			},
			{
				name: 'Data',
				template: 'kform/components/smartfield/data.html',
			},
			{
				name: 'Validation',
				template: 'kform/components/common/validate.html',
			},
			{
				name: 'API',
				template: 'kform/components/common/api.html',
			},
			{
				name: 'Layout',
				template: 'kform/components/common/layout.html',
			},
			{
				name: 'Conditional',
				template: 'kform/components/common/conditional.html',
			},
			{
				name: 'Events',
				template: 'kform/components/common/events.html',
			},
		],
		controller:    /* @ngInject */ (/** @type {any} */ $scope) => {
			$scope.changeValue = () => {
				if (typeof $scope.component.event?.onChange === 'string') {
					const custom = ''.concat($scope.component.event.onChange, '; ');
					kformUtils.evaluate(custom, {
						data: $scope.data,
						form: $scope.form,
					});
				}
			};
		},
		onEdit: /* @ngInject */ (/** @type {any} */ $scope) => {
			$scope.tmpDefaultValue = angular.copy($scope.component.defaultValue);

			$scope.$watch('tmpDefaultValue', () => {
				const values = $scope.tmpDefaultValue?.map((/** @type {any} */ v) => ({
					kid:  v.kid,
					name: v.name,
				}));
				if (Array.isArray(values) && values.length > 0) {
					$scope.component.defaultValue = values[0];
				}
			}, true);
		}
	});
};

export default angular.module('app').config(smartfieldConfig);
